import { CreateFeedPage } from "./CreateFeedPage";

export default CreateFeedPage;